// Country name → ISO-2 code mapping (and Russian + English aliases).
const CODE = {
  "Казахстан": "kz", "Kazakhstan": "kz",
  "Узбекистан": "uz", "Uzbekistan": "uz",
  "Кыргызстан": "kg", "Киргизия": "kg", "Kyrgyzstan": "kg",
  "Таджикистан": "tj", "Tajikistan": "tj",
  "Туркменистан": "tm", "Turkmenistan": "tm",
  "Россия": "ru", "Russia": "ru",
  "Беларусь": "by", "Belarus": "by",
  "Украина": "ua", "Ukraine": "ua",
  "Молдова": "md", "Moldova": "md",
  "Грузия": "ge", "Georgia": "ge",
  "Армения": "am", "Armenia": "am",
  "Азербайджан": "az", "Azerbaijan": "az",
  "Польша": "pl", "Poland": "pl",
  "Германия": "de", "Germany": "de",
  "Великобритания": "gb", "Англия": "gb", "United Kingdom": "gb", "UK": "gb",
  "Нидерланды": "nl", "Netherlands": "nl",
};

export const countryCode = (name) => CODE[name?.trim()] || null;

const Flag = ({ country, size = 18, className = "" }) => {
  const code = countryCode(country);
  if (!code) {
    return (
      <span className={`inline-flex items-center justify-center rounded-full bg-muted text-muted-foreground ${className}`} style={{ width: size + 6, height: size, fontSize: size * 0.55 }}>
        🌍
      </span>
    );
  }
  const w = Math.round(size * 1.33);
  return (
    <img
      src={`https://flagcdn.com/w40/${code}.png`}
      srcSet={`https://flagcdn.com/w40/${code}.png 1x, https://flagcdn.com/w80/${code}.png 2x`}
      width={w}
      height={size}
      alt=""
      className={`inline-block rounded-[3px] object-cover shadow-sm ring-1 ring-black/5 ${className}`}
      style={{ width: w, height: size }}
      loading="lazy"
    />
  );
};

export default Flag;
